/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageReview = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V13h-2V9h-5V4H6v16h7v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M22 20.889h-3.66l-1.175.904-.27.207H15v-7h7zm-5-1.492.39-.3.27-.208H20V17h-3zM13 17H8v-2h5zm3-4H8v-2h8zm-5-4H8V7h3z" />
      </g>
    </g>
  </Icon>
);
export { SvgPageReview as PageReview };
